import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

interface GuestAuthResponse {
  accessToken: string;
  refreshToken: string;
  expiry: number; // Assuming expiry is a string in ISO format e.g. "2025-05-14T10:07:10.562Z"
}

// Define the base URL for auth using the environment variable
const authBaseUrl = `${import.meta.env.VITE_API_BASE_URL}/api/v1/`;

export const guestAuthApi = createApi({
  reducerPath: "guestAuthApi",
  baseQuery: fetchBaseQuery({
    baseUrl: authBaseUrl,
    credentials: 'include',
  }),
  endpoints: (builder) => ({
    guestLogin: builder.mutation<GuestAuthResponse, void>({
      query: () => ({
        url: "guest-login",
        method: "POST",
        body: {}, // Empty body as per the specification
      }),
    }),
  }),
});

export const { useGuestLoginMutation } = guestAuthApi; 